import styled from 'styled-components'

export const DocumentationWrapper = styled.div`
  position: relative;
`



// WEBPACK FOOTER //
// ./src/Components/Settings/Documentation/DocumentationWrapper/index.js